export const boztTypes = ['like_my_bozt', 'bookmark_my_bozt', 'circle_add_bozt', 'share_my_bozt', 'circle_update_bozt']
export const commentBozt = ['comment_my_bozt']
export const userTypes = ['someone_follow', 'invite_bozt', 'join_bozt']
export const favorites = ['circle_add_favotite']
